import {Action} from "../../../actions/actions";
import {PresetsActionTypes} from "../actions/actionTypes";

export interface Game {
    id?: number;
    name: string;
    type: number;
    software_house: string;
    image: string;
    game_type: any;
    client: any;
    feature: any;
    trademark: any;
    series: any;
    platform: any;
}

export function games(state: any[] = [],
                      action: Action) {
    switch (action.type) {
        case PresetsActionTypes.GET_GAMES_SUCCESS:
            return action.payload.games.results;
        default:
            return state;
    }
}

export function gamesLoading(state: boolean = false, action: Action) {
    switch (action.type) {
        case PresetsActionTypes.GET_GAMES:
            return true;

        case PresetsActionTypes.GET_GAMES_FAIL:
        case PresetsActionTypes.GET_GAMES_SUCCESS:
            return false;

        default:
            return state;
    }
}

export function gameBundles(
    state: any[] = [],
    action: Action
) {
    switch (action.type) {
        case PresetsActionTypes.GET_BUNDLES_SUCCESS:
            return action.payload.gameBundles.results;
        default:
            return state;
    }
}

export function gameBundlesLoading(state: boolean = false, action: Action) {
    switch (action.type) {
        case PresetsActionTypes.GET_BUNDLES:
            return true;

        case PresetsActionTypes.GET_BUNDLES_FAIL:
        case PresetsActionTypes.GET_BUNDLES_SUCCESS:
            return false;

        default:
            return state;
    }
}
